import { createAction, props } from '@ngrx/store';
import { IUserDetailsState } from './user-details.state';

export const setUserDetailsData = createAction(
  '[User Details] Set User Details Data',
  props<{ data: IUserDetailsState }>()
);

export const clearUserDetailsData = createAction(
  '[User Details] Clear User Details Data'
);
